<template>
  <a-modal
    :width="1000"
    :visible="visible"
    title="上传"
    @ok="submit"
    okText="提交"
    @cancel="cancel"
    :confirm-loading="loading"
  >
    <a-descriptions title="任务要求" :column="2" bordered>
      <a-descriptions-item label="任务名称">
        {{ modal.workerName }}
      </a-descriptions-item>
      <a-descriptions-item label="任务描述">
        <span v-html="modal.content"></span>
      </a-descriptions-item>
      <a-descriptions-item label="开始时间">
        {{ modal.startTime }}
      </a-descriptions-item>
      <a-descriptions-item label="截止时间">
        {{ modal.endTime }}
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions
      title="文件上传"
      :column="1"
      bordered
      style="margin-top:16px"
    >
      <a-descriptions-item label="资源目录" v-if="false">
        {{ modal.resource }}
      </a-descriptions-item>
      <a-descriptions-item label="资源目录">
        <a-cascader
          @change="onChange"
          :options="optionsCatalog"
          placeholder="请选择资源目录"
          change-on-select
          style="width: 100%"
          :value="catalog"
          :fieldNames="{ label: 'name', value: 'id', children: 'jtypes' }"
        >
        </a-cascader>
      </a-descriptions-item>
      <a-descriptions-item label="文件列表">
        <a-upload
          name="files"
          :accept="allowFileTypes"
          multiple
          :action="uploadURL"
          :headers="headers"
          :fileList="fileList"
          @change="handleChange"
        >
          <a-button type="default" icon="upload">上传文件</a-button>
          <span style="padding-left:20px;font-size:12px;"
            >上传文件格式：年纪+科目+周+考/学/教情/作业设计</span
          >
        </a-upload>
      </a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>
<script>
import storage from "store";
import { USER_TOKEN } from "@/store/mutation-types";
import { ALLOW_UPLOAD_FILE_TYPE } from "@/constants/upload";
import { upload } from "@/api/base/uploadTask/manager";
import { WARN_MESSAGE_TITLE } from "@/constants/message";
import moment from "moment";
import { trees } from "@/api/base/tree/manager";
import { CATALOG_INDEX, CATALOG_LENGTH } from "@/constants/task";
import { getTypeNames } from "@/utils/treeTypeUtil";

export default {
  data() {
    return {
      //modal
      visible: false,
      modal: {},
      loading: false,
      //upload
      uploadURL: window._CONFIG["uploadURL"], //上传路径
      headers: { user_token: storage.get(USER_TOKEN) },
      fileList: [],
      allowFileTypes: ALLOW_UPLOAD_FILE_TYPE,

      // 资源类目列表
      optionsCatalog: [],
      catalog: []
    };
  },
  mounted() {
    // 加载资源目录列表
    this.loadCatalog();
  },
  methods: {
    // 资源目录改变
    onChange(value) {
      console.log(value);
      this.catalog = value;
    },

    // 加载资源目录列表
    loadCatalog() {
      // 请求资源目录列表
      trees().then(res => {
        if (1 == res.resultCode) {
          this.optionsCatalog = res.result;
        }
      });
    },

    //upload Change事件
    handleChange(info) {
      let fileList = [...info.fileList];
      // 上传文件列表结果处理
      fileList = fileList.filter(file => {
        if (file.response) {
          let result = file.response;
          if (0 != result.resultCode) {
            file.url = file.response.result[0].filePath;
            return true;
          } else {
            this.$notification.error({
              message: WARN_MESSAGE_TITLE,
              description: result.message
            });
            return false;
          }
        }
        return true;
      });

      this.fileList = fileList;
    },
    show(record) {
      this.catalog = [];

      this.visible = true;
      if (record) {
        this.modal = record;

        this.modal.startTime = moment(this.modal.startTime).format(
          "YYYY-MM-DD"
        );
        this.modal.endTime = moment(this.modal.endTime).format("YYYY-MM-DD");
      }
    },
    cancel() {
      this.visible = false;
      this.modal = {};
      this.fileList = [];
    },
    //提交
    submit() {
      let that = this;
      this.$confirm({
        title: "提示",
        content: "是否确认提交",
        onOk() {
          // 对资源目录进行单独判断
          let catalog = that.catalog;
          if (
            !catalog ||
            (CATALOG_LENGTH != catalog.length &&
              CATALOG_INDEX != catalog.length)
          ) {
            that.$notification["warning"]({
              message: "请选择所属资源！"
            });
            return;
          }
          that.modal.typeId = catalog[catalog.length - 1];
          that.modal.typeName = getTypeNames(that.optionsCatalog, catalog, 0);

          that.loading = true;
          let arrIds = [];
          let arrNames = [];
          if (that.fileList.length > 0)
            that.fileList.forEach(item => {
              if (item.response) {
                arrIds.push(item.response.result[0].id);
                arrNames.push(
                  that.modal.typeName + "_" + item.response.result[0].fileName
                );
              }
            });
          that.modal.arrIds = arrIds.toString();
          that.modal.arrNames = arrNames.toString();
          upload({ ...that.modal }).then(res => {
            that.$notification[res.resultCode === 1 ? "success" : "error"]({
              message: res.message
            });

            if (0 != res.resultCode) {
              that.$emit("initData");
              that.cancel();
            }

            that.loading = false;
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped></style>
